import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'

import cls from '../styles.module.scss'

export const TextContentDe = () => {
    return (
        <HighlightedText
            text="325% Einzahlungsbonus + 400 FREISPIELE"
            highlights={[{ word: '400' }, { word: '325%' }]}
            breakAfterWords={['Einzahlungsbonus']}
            className={cls.text}
        />
    )
}
